import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';

export interface DatasetCardData {
  id: string;
  title: string;
  shortDescription?: string;
  organization: string;
  tags: string[];
  fileType?: string;
  dateLabel: string;
  badge?: string;
  badgeColor?: 'public' | 'restricted' | 'private';
  isNew?: boolean;
  link?: string;
  metrics?: {
    likes?: number;
    views?: number;
    downloads?: number;
    files?: number;
  };
}

@Component({
  selector: 'app-dataset-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dataset-card.html',
  styleUrl: './dataset-card.scss',
})
export class DatasetCard {
  private router = inject(Router);
  private googleAnalytics = inject(GoogleAnalyticsService);

  @Input({ required: true }) card!: DatasetCardData;

  formatMetric(n: number | undefined): string {
    const v = n ?? 0;
    if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
    if (v >= 1_000) return `${(v / 1_000).toFixed(1)}k`;
    return String(v);
  }

  getBadgeModifierClass(): string {
    const c = this.card.badgeColor ?? 'public';
    // Restricted matches Public chip colors; icon is a lock instead of a globe.
    if (c === 'restricted') {
      return 'dataset-card__badge--public';
    }
    return `dataset-card__badge--${c}`;
  }

  onCardClick(): void {
    if (this.card?.id) {
      this.googleAnalytics.trackDatasetClick(this.card.title ?? '', this.card.id);
      void this.router.navigate(['/datasets', this.card.id]);
    } else if (this.card?.link) {
      void this.router.navigateByUrl(this.card.link);
    }
  }

  onArrowClick(event: Event): void {
    event.stopPropagation();
    this.onCardClick();
  }
}
